// console.log('app.js loaded')

//import { FetchRequest } from "@rails/request.js";
import * as bootstrap from "bootstrap";
import TomSelect from "tom-select";

function initMisc() {
  // console.log('initialize');
  /*
  const checkElementClassName = "initialize-check-element";
  if (document.querySelector(`.${checkElementClassName}`)) {
    // console.log('already init');
    // console.log(document.querySelector(`.${checkElementClassName}`));
    return;
  }

  const checkEl = document.createElement("div");
  checkEl.style.display = "none";
  checkEl.className = checkElementClassName;
  document.body.appendChild(checkEl);
  */

  // Popover
  const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]',
  );
  const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl),
  );

  // 管理者用 専門家カレンダーのポップオーバー
  const popoverTriggerList2 = document.querySelectorAll(
    '[data-bs-toggle="manage-calendar-popover"]',
  );
  const popoverList2 = [...popoverTriggerList2].map(
    (popoverTriggerEl) =>
      new bootstrap.Popover(popoverTriggerEl, {
        content: popoverTriggerEl
          .closest(".event")
          .querySelector(".popover-content").innerHTML,
        html: true,
      }),
  );

  // エラーメッセージがあれば、画面内にスクロール
  setTimeout(function () {
    const errorMessage = document.querySelector(".error-message.alert");
    if (errorMessage) {
      errorMessage.scrollIntoView({ block: "center" });
    }
  }, 0);

  // ファイル添付の削除
  document.querySelectorAll(".remove-attachment").forEach((element) => {
    element.addEventListener("click", (event) => {
      const container = event.target.closest(".remove-attachment-container");
      container.querySelector(".remove-attachment-checkbox").checked = true;
      container.style.display = "none";
    });
  });

  // 同意チェックボックスをスクロールしたらenabled
  document.querySelectorAll(".need-to-read-rules").forEach((element) => {
    function checkReading() {
      if (checkReading.read) {
        return;
      }
      checkReading.read =
        this.scrollHeight - Math.round(this.scrollTop) - 5 <= this.clientHeight;
      if (checkReading.read) {
        element.disabled = !checkReading.read;
      }
    }

    const oToBeRead = document.querySelector(
      element.dataset.needToReadRulesTarget,
    );
    if (oToBeRead) {
      oToBeRead.onscroll = checkReading;
      checkReading.call(oToBeRead);
    }
  });

  // usr form
  document.querySelectorAll(".check-influencer").forEach((element) => {
    // チェックボックスまたはラジオボタン .check-influencer のチェック状況に応じて、対象の要素を表示非表示を切り換える
    const target = document.querySelector(
      element.dataset.checkInfluencerTarget,
    );
    if (target) {
      function checkInfluencer() {
        target.style.display = element.checked ? "block" : "none";
      }
      // 同じnameの要素全てにイベントを設定
      document
        .querySelectorAll(`input[name="${element.name}"]`)
        .forEach((element2) => {
          element2.addEventListener("change", checkInfluencer);
        });
      //element.addEventListener("change", checkInfluencer);
      checkInfluencer();
    }
  });
  document
    .querySelectorAll(".check-modify-class-influencer")
    .forEach((element) => {
      //console.log("check-modify-class-influencer", element);
      // チェックボックスまたはラジオボタン .check-influencer のチェック状況に応じて、対象の要素を表示非表示を切り換える
      const target = document.querySelector(
        element.dataset.checkInfluencerTarget,
      );
      //console.log("target", target);
      if (target) {
        function checkInfluencer() {
          const disabledClassname = "document-disabled";
          const notrequiredClassname = "notrequired";
          const checkedEls = document.querySelectorAll(
            `input[type="${element.type}"][name="${element.name}"]:checked`,
          );
          const notCheckedEls = document.querySelectorAll(
            `input[type="${element.type}"][name="${element.name}"]:not(:checked)`,
          );
          let selectedTargets = [];
          let notSelectedTargets = [];
          if (checkedEls.length > 0) {
            const selector = Array.from(checkedEls)
              .map((el) => {
                return el.dataset.checkSelectedTarget;
              })
              .join(", ");
            selectedTargets = document.querySelectorAll(selector);
          }
          if (notCheckedEls.length > 0) {
            const selector = Array.from(notCheckedEls)
              .map((el) => {
                return el.dataset.checkSelectedTarget;
              })
              .join(", ");
            notSelectedTargets = document.querySelectorAll(selector);
          }
          if (selectedTargets.length > 0) {
            toggleTargetDisable(selectedTargets, false);
          }
          if (notSelectedTargets.length > 0) {
            toggleTargetDisable(notSelectedTargets, true);
          }

          function toggleTargetDisable(targets, targetDisabled) {
            for (const theTarget of targets) {
              // row に document-disabled クラスを付与
              if (targetDisabled) {
                theTarget.classList.add(disabledClassname);
              } else {
                theTarget.classList.remove(disabledClassname);
              }

              // input を disabled にする
              theTarget.querySelectorAll("input").forEach((el) => {
                el.disabled = targetDisabled;
              });

              // form-label に notrequired クラスを付与
              const formLabelEls = theTarget.querySelectorAll(".form-label");
              if (formLabelEls.length > 0) {
                if (targetDisabled) {
                  //formLabelEl.classList.remove("required");
                  formLabelEls.forEach((formLabelEl) => {
                    formLabelEl.classList.add(notrequiredClassname);
                  });
                } else {
                  //formLabelEl.classList.add("required");
                  formLabelEls.forEach((formLabelEl) => {
                    formLabelEl.classList.remove(notrequiredClassname);
                  });
                }
              }
            }
          }
        }
        // イベントを設定
        element.addEventListener("change", checkInfluencer);
        checkInfluencer();
      }
    });
}

function initFlatpickr() {
  const pickers = document.querySelectorAll(".flatpickr");
  for (const picker of pickers) {
    const isFutureOnly = !!picker.dataset.futureOnly;
    const maxDateStr = picker.dataset.maxDate;
    const maxDate = maxDateStr
      ? new Date(maxDateStr + "T00:00:00+09:00")
      : null;
    flatpickr(picker, {
      locale: "ja",
      dateFormat: "Y年m月d日",
      disable: [
        function (date) {
          // return true to disable
          if (isFutureOnly) {
            // 過去の日付を選択不可にする
            if (date < new Date()) return true;
          }
          // 土日を選択不可にする
          if (date.getDay() === 0 || date.getDay() === 6) return true;
          // 祝日を選択不可にする
          if (isHoliday(date)) return true;
          if (maxDate) {
            // 指定された日の翌日以降を選択不可にする
            maxDate.setDate(maxDate.getDate() + 1);
            if (date > maxDate) return true;
          }

          return false;
        },
      ],
    });
  }
}
function formatDate(dt) {
  var y = dt.getFullYear();
  var m = ("00" + (dt.getMonth() + 1)).slice(-2);
  var d = ("00" + dt.getDate()).slice(-2);
  return y + "-" + m + "-" + d;
}
function isHoliday(date) {
  // rails側の helper にも同じものがあるので、そちらもあわせて更新すること

  // Holidays JP API (日本の祝日API)
  // https://holidays-jp.github.io/
  // 上記から取得したデータを static に持つ
  // https://holidays-jp.github.io/api/v1/date.json
  const holiday = {
    "2023-01-01": "元日",
    "2023-01-02": "休日 元日",
    "2023-01-09": "成人の日",
    "2023-02-11": "建国記念の日",
    "2023-02-23": "天皇誕生日",
    "2023-03-21": "春分の日",
    "2023-04-29": "昭和の日",
    "2023-05-03": "憲法記念日",
    "2023-05-04": "みどりの日",
    "2023-05-05": "こどもの日",
    "2023-07-17": "海の日",
    "2023-08-11": "山の日",
    "2023-09-18": "敬老の日",
    "2023-09-23": "秋分の日",
    "2023-10-09": "スポーツの日",
    "2023-11-03": "文化の日",
    "2023-11-23": "勤労感謝の日",
    "2024-01-01": "元日",
    "2024-01-08": "成人の日",
    "2024-02-11": "建国記念の日",
    "2024-02-12": "建国記念の日 振替休日",
    "2024-02-23": "天皇誕生日",
    "2024-03-20": "春分の日",
    "2024-04-29": "昭和の日",
    "2024-05-03": "憲法記念日",
    "2024-05-04": "みどりの日",
    "2024-05-05": "こどもの日",
    "2024-05-06": "こどもの日 振替休日",
    "2024-07-15": "海の日",
    "2024-08-11": "山の日",
    "2024-08-12": "休日 山の日",
    "2024-09-16": "敬老の日",
    "2024-09-22": "秋分の日",
    "2024-09-23": "秋分の日 振替休日",
    "2024-10-14": "スポーツの日",
    "2024-11-03": "文化の日",
    "2024-11-04": "文化の日 振替休日",
    "2024-11-23": "勤労感謝の日",
    "2025-01-01": "元日",
    "2025-01-13": "成人の日",
    "2025-02-11": "建国記念の日",
    "2025-02-23": "天皇誕生日",
    "2025-02-24": "天皇誕生日 振替休日",
    "2025-03-20": "春分の日",
    "2025-04-29": "昭和の日",
    "2025-05-03": "憲法記念日",
    "2025-05-04": "みどりの日",
    "2025-05-05": "こどもの日",
    "2025-05-06": "みどりの日 振替休日",
    "2025-07-21": "海の日",
    "2025-08-11": "山の日",
    "2025-09-15": "敬老の日",
    "2025-09-23": "秋分の日",
    "2025-10-13": "スポーツの日",
    "2025-11-03": "文化の日",
    "2025-11-23": "勤労感謝の日",
    "2025-11-24": "勤労感謝の日 振替休日",
    "2026-01-01": "元日",
    "2026-01-12": "成人の日",
    "2026-02-11": "建国記念の日",
    "2026-02-23": "天皇誕生日",
    "2026-03-20": "春分の日",
    "2026-04-29": "昭和の日",
    "2026-05-03": "憲法記念日",
    "2026-05-04": "みどりの日",
    "2026-05-05": "こどもの日",
    "2026-05-06": "振替休日",
    "2026-07-20": "海の日",
    "2026-08-11": "山の日",
    "2026-09-21": "敬老の日",
    "2026-09-22": "祝日法第3条第3項による休日",
    "2026-09-23": "秋分の日",
    "2026-10-12": "スポーツの日",
    "2026-11-03": "文化の日",
    "2026-11-23": "勤労感謝の日",
  };
  return holiday[formatDate(date)];
}

function reflectDependentElement(el) {
  let show;
  const value_includes = el.dataset.reflectToValueIncludes;
  if (el.tagName === "SELECT" && value_includes) {
    show = el.value.includes(value_includes);
  } else if (el.tagName === "INPUT" && el.type === "radio" && value_includes) {
    show = false;
    const checkedEl = el
      .closest("form")
      .querySelector(`input[name="${el.name}"]:checked`);
    if (checkedEl) {
      show = checkedEl.value.includes(value_includes);
    }
  } else {
    show = !!el.checked;
  }
  const targets = document.querySelectorAll(el.dataset.reflectTo);
  targets.forEach((target) => {
    target.style.display = show ? "" : "none";
    // 全て disabled にする
    target.querySelectorAll("input").forEach((element) => {
      element.disabled = !show;
    });
  });
}
function setReflectDependentElement() {
  document
    .querySelectorAll("input[data-reflect-to], select[data-reflect-to]")
    .forEach((element) => {
      const setuped = element.dataset.reflectToSetuped;
      // 多重セットアップを防止
      if (!setuped) {
        element.addEventListener("change", (event) => {
          reflectDependentElement(event.target);
        });
        reflectDependentElement(element);
        element.dataset.reflectToSetuped = true;
      }
    });
}

// 医薬品詳細
// Tom Select 初期化
function initTomSelect() {
  document.querySelectorAll(".tom-select").forEach(function (element) {
    if (!element.tomSelect) {
      // 重複初期化防止
      new TomSelect(element, {
        maxItems: 1,
        allowEmptyOption: true,
        searchField: ["text", "value"],
        plugins: ["clear_button"],
        render: {
          no_results: function () {
            return '<div class="no-results">見つかりません</div>';
          },
        },
      });
    }
  });
}

function initMedicineShow() {
  // console.log("initMedicineShow called");
  const selectAllCheckbox = document.getElementById("select-all");
  const medicineCheckboxes = document.querySelectorAll(".medicine-checkbox");
  const createTicketsBtn = document.getElementById("create-tickets-btn");
  const clickableRows = document.querySelectorAll(".clickable-row");

  // モード切り替え機能（新機能）
  const switchToAllBtn = document.getElementById("switch-to-all");
  const switchToRelatedBtn = document.getElementById("switch-to-related");
  const relatedTbody = document.getElementById("related-medicines-tbody");
  const searchedTbody = document.getElementById("searched-medicines-tbody");
  const searchForm = document.getElementById("search-form");
  const productsTitleRelated = document.getElementById("products-title-related");
  const productsTitleAll = document.getElementById("products-title-all");

  let currentMode = "related"; // "related" or "all"

  // 行クリックでチェックボックスをトグル
  clickableRows.forEach((row) => {
    row.addEventListener("click", function (e) {
      if (e.target.type !== "checkbox") {
        const checkbox = this.querySelector(".medicine-checkbox");
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          updateSelectAllState();
          updateButtonState();
        }
      }
    });
  });

  // 全選択チェックボックスの動作
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener("change", function () {
      const activeTbody = currentMode === "related" ? relatedTbody : (searchedTbody || document);
      const activeCheckboxes = activeTbody
        ? activeTbody.querySelectorAll(".medicine-checkbox")
        : medicineCheckboxes;

      activeCheckboxes.forEach((checkbox) => {
        checkbox.checked = this.checked;
      });
      updateButtonState();
    });
  }

  // 個別チェックボックスの動作
  medicineCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      updateSelectAllState();
      updateButtonState();
    });
  });

  // 全選択状態の更新
  function updateSelectAllState() {
    const activeTbody = currentMode === "related" ? relatedTbody : (searchedTbody || document);
    const activeCheckboxes = activeTbody
      ? activeTbody.querySelectorAll(".medicine-checkbox")
      : medicineCheckboxes;
    const checkedCount = Array.from(activeCheckboxes).filter(
      (cb) => cb.checked,
    ).length;
    const totalCount = activeCheckboxes.length;

    if (selectAllCheckbox) {
      selectAllCheckbox.checked = checkedCount === totalCount && totalCount > 0;
      selectAllCheckbox.indeterminate =
        checkedCount > 0 && checkedCount < totalCount;
    }
  }

  // ボタンの有効/無効状態の更新
  function updateButtonState() {
    const checkedCount = document.querySelectorAll(
      ".medicine-checkbox:checked",
    ).length;
    if (createTicketsBtn) {
      const isDisabled = createTicketsBtn.classList.contains("btn-warning");
      createTicketsBtn.disabled = isDisabled || checkedCount === 0;
    }
  }

  // モード切り替え機能（新機能）
  if (switchToAllBtn && switchToRelatedBtn && relatedTbody && searchedTbody) {
    // URLパラメータから検索モードを判定
    const urlParams = new URLSearchParams(window.location.search);
    const isSearchMode = urlParams.get("search_all") === "true";

    // ページロード時に検索モードだった場合、モードを切り替え
    if (isSearchMode) {
      currentMode = "all";
      switchMode();
    }

    // モード切り替え
    function switchMode() {
      if (currentMode === "related") {
        relatedTbody.style.display = "";
        searchedTbody.style.display = "none";
        if (searchForm) searchForm.style.display = "none";
        productsTitleRelated.style.display = "";
        productsTitleAll.style.display = "none";
        switchToAllBtn.style.display = "";
        switchToRelatedBtn.style.display = "none";
      } else {
        relatedTbody.style.display = "none";
        searchedTbody.style.display = "";
        if (searchForm) searchForm.style.display = "block";
        productsTitleRelated.style.display = "none";
        productsTitleAll.style.display = "";
        switchToAllBtn.style.display = "none";
        switchToRelatedBtn.style.display = "";
      }

      // 全選択をリセット
      selectAllCheckbox.checked = false;
      updateButtonState();
    }

    switchToAllBtn.addEventListener("click", function() {
      currentMode = "all";
      switchMode();
    });

    switchToRelatedBtn.addEventListener("click", function() {
      currentMode = "related";
      switchMode();
    });
  }

  // 初期状態でボタンの状態を更新
  updateButtonState();
}

function initialize() {
  // console.log("initialize called");
  initMisc();
  initTomSelect();
  initMedicineShow();
  initFlatpickr();
  setReflectDependentElement();
}

document.addEventListener("turbo:load", () => {
  // console.log("turbo:load event fired");
  document.querySelectorAll(".clear-search-query").forEach((element) => {
    element.addEventListener("click", (event) => {
      document.querySelector("#search-query").value = "";
    });
  });
  document
    .querySelectorAll(
      "#search-role, #search-deleted, #search-status, .on-changed-do-search",
    )
    .forEach((element) => {
      element.addEventListener("change", (event) => {
        //event.target.form.submit();
        document.querySelector(".do-search").click();
      });
    });

  initialize();

  if (location.pathname === "/users/sign_up") {
    /*
    // vent snippet for 学生向け_登録申込ボタンクリック conversion page
    gtag("event", "conversion", {
      send_to: "AW-11219132688/2o9xCPS2jpAZEJDC2eUp",
    });
    */
  }
});
window.addEventListener("turbo:submit-end", (event) => {
  // console.log("turbo:submit-end event fired");
  if (event.detail && event.detail.success) {
    // 成功時は turbo:load event が発火する
  } else {
    // 失敗時は turbo:load event が発火しない
    // console.log("turbo:submit-end failed, so calling initialize directly");
    initialize();
  }
});

/*
document.addEventListener("turbo:render", () => {
  console.log("turbo:render event fired");

  initialize();
});
window.addEventListener("turbo:submit-end", () => {
  // console.log("turbo:submit-end event fired");
  // 次の turbo:render 時に 1回だけ load 相当の処理を実行したい
  (function () {
    var fn = function () {
      // console.log("turbo:submit-end and next time turbo-render event fired");

      initialize();

      document.removeEventListener("turbo:render", fn);
    };
    document.addEventListener("turbo:render", fn);
  })();
});
window.addEventListener("load", () => {
  console.log("load event fired");
});
window.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded event fired");
});
document.addEventListener("turbo:load", () => {
  console.log("turbo:load event fired");
});
*/
